import T1 from './T1';   // root
import T2 from './T2';   // VRGroup
import T8 from './T8';   // Mikkelin Vesilaitos
import T13 from './T13'; // Joensuun vesi
import T14 from './T14'; // NEVE

export default {
  1: T1,
  2: T2,
  8: T8,
  13: T13,
  14: T14
};
